import React from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"

import Markdown from "@components/Markdown"

const { Text } = Typography

const LABEL_COMPLETE = "Complete"
const LABEL_INCOMPLETE = "Incomplete"
const LABEL_PENDING = "Pending"
const LABEL_PARTIALLY_FUNDED = "Partially Funded"
const LABEL_OVERFUNDED = "Overfunded"
const LABEL_FAILED = "Failed"


const InvestmentProfileCardItem = ({ title, subtitle, isComplete, isPending, isFailed, children, status }) => {
  if (!status) {
    status = isComplete ? LABEL_COMPLETE : LABEL_INCOMPLETE
    status = isPending ? LABEL_PENDING : status
    status = isFailed ? LABEL_FAILED : status
  }

  const isOverFunded = status === LABEL_OVERFUNDED
  const isPartiallyFunded = status === LABEL_PARTIALLY_FUNDED

  status = isFailed ? LABEL_FAILED : status

  let styleType = "danger"

  if (isPending) styleType = "warning"

  if (isComplete) styleType = "success"

  if (isOverFunded) styleType = "danger"

  if (isPartiallyFunded) styleType = "warning"

  if (isFailed) styleType = "danger"

  const components = {
    p(props) {
      const { children: content } = props

      return (
        <p style={{ marginTop: 0, marginBottom: 12 }}>
          {content}
        </p>
      )
    }
  }

  return (
    <>
      <Text>
        <Text style={{ fontSize: 16 }} strong>{title}:</Text>
        <Text style={{ fontSize: 16 }} strong type={styleType}>{' '}
          {status}
        </Text>

        <Markdown text={subtitle} components={components} />
      </Text>

      {children}
    </>
  )
}

InvestmentProfileCardItem.propTypes = {
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.shape({}) ]).isRequired,
  status: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
}

InvestmentProfileCardItem.defaultProps = {
  status: undefined,
}

export default InvestmentProfileCardItem
